import jiaowuReportPopup from './jiaowu-report/popup';

export default [...jiaowuReportPopup];
